import dynamic from 'next/dynamic'
import { useInView } from 'react-intersection-observer'

import Image from '@web/components/Image'
import { gql } from '@web/gql'
import { ReviewGroupVideoCard_VideoItemFragment } from '@web/gql/graphql'
import { isTypename } from '@web/libs/apollo/typeGuard'
import photoInfra from '@web/libs/media/photoInfra'

import styles from './ReviewGroupCard.module.scss'

const TrailerContainer = dynamic(() => import('../../../../../../components/ThumbnailPreviewPlayer'), {
  ssr: false,
})

type Props = {
  videoItem: ReviewGroupVideoCard_VideoItemFragment
}

const ReviewGroupVideoCard = ({ videoItem }: Props) => {
  const { ref: viewRef, inView } = useInView({ threshold: 0.9 })

  if (videoItem.isIllegalVideo || isTypename(videoItem.trailer, 'TrailerFailed')) {
    return (
      <Image
        className={styles.img}
        src={videoItem.thumbnail}
        thumbnailType={photoInfra.type.f510_510_70_sharpen}
        width="100%"
        height="100%"
        alt=""
      />
    )
  }

  return (
    <div className={styles.img} ref={viewRef}>
      <TrailerContainer videoItem={videoItem} isPlay={inView} />
    </div>
  )
}

ReviewGroupVideoCard.fragments = gql(`
  fragment ReviewGroupVideoCard_VideoItem on VideoItem {
    id
    type
    thumbnail
    isIllegalVideo
    ...ThumbnailPreviewPlayer_VideoItem
  }
`)

export default ReviewGroupVideoCard
